export interface ThemeClasses {
  bg: string;
  border: string;
  text: string;
  textSecondary: string;
  cardBg: string;
  cardBorder: string;
  buttonHover: string;
  buttonText: string;
  buttonTextHover: string;
}

export interface AlertState {
  show: boolean;
  title: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
}

export const AVAILABLE_APPS = [
  { id: "torre-control", label: "Torre de Control" },
  { id: "lite", label: "Lite" },
  { id: "oasis", label: "Oasis" },
  { id: "reseller-admin", label: "Reseller Admin" },
  { id: "facturacion", label: "Facturación" },
  { id: "cobranza", label: "Cobranza" },
  { id: "reportes", label: "Reportes" },
  { id: "dashboards", label: "Dashboards" },
  { id: "entrega-servicio", label: "Entrega de Servicio" },
  { id: "logistica", label: "Logística" },
] as const;

export const ENTITY_LIMIT_KEYS = [
  { key: "vehicles", label: "Vehículos", icon: "ri-truck-line" },
  { key: "devices", label: "Dispositivos", icon: "ri-cpu-line" },
  { key: "users", label: "Usuarios", icon: "ri-user-line" },
  { key: "geofences", label: "Geocercas", icon: "ri-map-pin-line" },
  { key: "drivers", label: "Conductores", icon: "ri-steering-2-line" },
  { key: "groups", label: "Grupos", icon: "ri-folder-line" },
  { key: "alerts", label: "Alertas", icon: "ri-alarm-warning-line" },
  { key: "reports", label: "Reportes", icon: "ri-file-chart-line" },
] as const;

export const BILLING_MODELS = [
  { value: "per_unit", label: "Por Unidad/Dispositivo" },
  { value: "flat", label: "Tarifa Fija" },
  { value: "tiered", label: "Escalonado" },
] as const;

export const BILLING_CYCLES = [
  { value: "monthly", label: "Mensual" },
  { value: "quarterly", label: "Trimestral" },
  { value: "yearly", label: "Anual" },
] as const;

export const CURRENCIES = [
  { value: "MXN", label: "MXN (Peso Mexicano)" },
  { value: "USD", label: "USD (Dólar)" },
] as const;

export const STATUS_OPTIONS = [
  { value: "active", label: "Activa", color: "green" },
  { value: "inactive", label: "Inactiva", color: "red" },
  { value: "draft", label: "Borrador", color: "yellow" },
] as const;
